import React, {Component} from 'react';
import {connect} from 'react-redux';

import {getTranslate, getActiveLanguage} from 'react-localize-redux';
import _ from 'lodash';

import * as actions from '../../../../actions';
import Step from '../../../parts/Step';
import {Maybe} from '../../../../utils/logging';
import {setLanguageIndex, checkboxLog, selectLog, extractRH, generateSummary} from '../../../../utils/helpers';

class WtSummary extends Component {

    render() {
        const details = [];
        let depthValue = this.props.wt.RH && extractRH(this.props.wt.RH) ? 'x ' + extractRH(this.props.wt.RH) : '';
        const getLanguageIndex = setLanguageIndex(this.props.currentLanguge);
        const getS023 = generateSummary(this.props.wt.SO23,getLanguageIndex);
        const getS045 = generateSummary(this.props.wt.SO45,getLanguageIndex);
        const getS067 = generateSummary(this.props.wt.SO67,getLanguageIndex);
        const gets081 = generateSummary(this.props.wt.SO81,getLanguageIndex);
        Maybe.of(this.props.wt.W_BREITE && this.props.wt.WT_TIEFE)
            .map(() => {
                return this.props.wt.W_BREITE.CurrentValue && this.props.wt.WT_TIEFE.CurrentValue
            })
            .map(() => {
                if (parseInt(this.props.wt.VAR_ABM.CurrentValue) === 0) {
                    details.push(`${this.props.translate(`WT.stepOne.menu.body.1`)} ${this.props.wt.W_TIEFE.CurrentValue} cm x ${this.props.wt.W_BREITE.CurrentValue} cm ${depthValue}`);
                    details.push(`${gets081 ? gets081 : ''}`);
                    details.push(`${getS023 ? getS023 : ''}`);
                    details.push(`${getS045 ? getS045 : ''}`)
                    details.push(`${getS067 ? getS067 : ''}`)
                }
            });
        Maybe.of(this.props.wt.VAR_ABM)
            .map((var_abm) => {
                details.push(`${this.props.translate(`WT.stepOne.menu.body.2`)} ${this._calculateSize('breite')} cm x ${this._calculateSize('tiefe')} cm ${depthValue}`);
            });

        const WT_AM = (field) => {
        return Maybe.of(field)
            .map((field) => {
                return parseFloat(field.CurrentValue);
            })
            .map((field_value) => {
                details.push(`${this.props.translate(`WT.stepOne.menu.left`)} ${field_value} cm`);
                return;
            })
        };

        WT_AM(this.props.wt.WT_AM);

        const WT_AMV = (field) => {
        return Maybe.of(field)
            .map((field) => {
                return parseFloat(field.CurrentValue);
            })
            .map((field_value) => {
                details.push(`${this.props.translate(`WT.stepOne.menu.front`)} ${field_value} cm`);
                return;
            })
        };

        WT_AMV(this.props.wt.WT_AMV);

        // Define wt_alaz_checkbox
        let wt_alaz_checkbox = '';
        // Define wt_als_checkbox
        let wt_als_checkbox = '';

        // Set WT_ALP2
        const WT_ALP2 = (wt_alaz, wt_alp1) => {
            return Maybe.of(selectLog(this.props, 'wt', 'WT_ALP2', `${setLanguageIndex(this.props.currentLanguage)}`)._value)
            .map((value) => {
                details.push(`${wt_alaz_checkbox}: ${wt_alaz} ${wt_alp1} ${value}`)
                return true;
            })
        }
        // Set WT_ALP1
        const WT_ALP1 = (wt_alaz) => {
            return Maybe.of(selectLog(this.props, 'wt', 'WT_ALP1',`${setLanguageIndex(this.props.currentLanguage)}`)._value)
            .map((value) => {
                return value;
            })
            .map((wt_alp1) => {
                return WT_ALP2(wt_alaz, wt_alp1)
                .orElseFun(() => {
                    details.push(`${wt_alaz_checkbox}: ${wt_alaz} ${wt_alp1}`);
                    return true;
                })
            })
        }

        // Set WT_ALAZ
        const WT_ALAZ = (() => {
            return Maybe.of(checkboxLog(this.props, 'wt', 'MISSING_WT_ALAZ_checkbox', 'stepTwo')._value)
            .map((value) => {
                wt_alaz_checkbox = value;
                return value;
            })
            .map(() => {
                return Maybe.of(selectLog(this.props, 'wt', 'WT_ALAZ',`${setLanguageIndex(this.props.currentLanguage)}`)._value)
                .map((value) => {
                    return value;
                })
                .map((wt_alaz) => {
                    return WT_ALP1(wt_alaz)
                    .orElseFun(() => {
                        details.push(`${wt_alaz_checkbox}: ${wt_alaz}`);
                        return true;
                    })
                })
                .join()
            })
        })();

        // Set WT_ALS
        const WT_ALS = (() => {
            return Maybe.of(checkboxLog(this.props, 'wt', 'MISSING_WT_ALS_checkbox', 'stepTwo')._value)
            .map((value) => {
                wt_als_checkbox = value;
                return value;
            })
            .map(() => {
                return Maybe.of(selectLog(this.props, 'wt', 'WT_ALS', `${setLanguageIndex(this.props.currentLanguage)}`)._value)
                .map((value) => {
                    details.push(`${wt_als_checkbox} ${value}`);
                    return true;
                })
                .join()
            })
        })()
        .orElseFun(() => {
            details.push(wt_als_checkbox);
        })


        // Set SSPV
        let sspv = '';

        // Set SSP
        const SSP = (() => {
            return Maybe.of(checkboxLog(this.props, 'wt', 'MISSING_SSPV_checkbox', 'stepTwo')._value)
            .map((value) => {
                sspv = value;
                return value;
            })
            .map(() => {
                return Maybe.of(selectLog(this.props, 'wt', 'SSP', `${setLanguageIndex(this.props.currentLanguage)}`)._value)
                .map((value) => {
                    if(this.props.wt.SSP.CurrentValue !== '00') {
                        details.push(`${sspv} ${value}`);
                    }
                    return true;
                })
                .join()
            })
        })();

        // Set ST
        Maybe.of(checkboxLog(this.props, 'wt', 'ST', 'stepTwo')._value)
        .map((value) => {
            details.push(value);
        });

        // Set HTH
        Maybe.of(checkboxLog(this.props, 'wt', 'HTH', 'stepTwo')._value)
        .map((value) => {
            details.push(value);
        });

        // Set KTSV
        let ktsv = '';

        // Set KTS
        const KTS = (() => {
            return Maybe.of(checkboxLog(this.props, 'wt', 'MISSING_KTSV_checkbox', 'stepThree')._value)
            .map((value) => {
                ktsv = value;
                return value;
            })
            .map(() => {
                return Maybe.of(selectLog(this.props, 'wt', 'KTS', `${setLanguageIndex(this.props.currentLanguage)}`)._value)
                .map((value) => {
                    if(this.props.wt.KTS.CurrentValue !== '00') {
                        details.push(`${ktsv} ${value}`);
                    }
                    return true;
                })
                .join()
            })
        })();

        // Set UL
        Maybe.of(checkboxLog(this.props, 'wt', 'UL_inverter', 'stepThree')._value)
        .map((value) => {
            details.push(value);
        });

        // Set FA
        Maybe.of(selectLog(this.props, 'wt', 'FA',`${setLanguageIndex(this.props.currentLanguage)}`)._value)
            .map((value) => {
                let farbe = this.props.translate(`WT.stepFour.menu.title2`);
                details.push(`${farbe}: ${value}`);
                return true;
            });

        // Set OV
        Maybe.of(checkboxLog(this.props, 'wt', 'OV', 'stepFour')._value)
            .map((value) => {
                details.push(value);
                return true;
            });

        return details.map((item, index) => {
            return (
                <div key={index}>{item}</div>
            )
        })
    }

    /**
     * _calculateSize for step one
     *
     */
    _calculateSize(type) {
        const getValue = (field) => {
            return Maybe.of(field)
            .map((field) => {
                return field.CurrentValue;
            })._value || 0;
        }
        if (type === 'tiefe') {
            if(parseInt(this.props.wt.VAR_ABM.CurrentValue) === 1) {
                return (parseInt(this.props.wt.WT_TIEFE.CurrentValue));
            } else {
                const w_tiefe = getValue(this.props.wt.WT_TIEFE);
                const SO45 = getValue(this.props.wt.SO45);
                const SO81 = getValue(this.props.wt.SO81);
                return w_tiefe + SO45 + SO81;
            }
        }
        if (type === 'breite') {
            if (parseInt(this.props.wt.VAR_ABM.CurrentValue) === 1) {
                return (parseInt(this.props.wt.W_BREITE.CurrentValue));
            } else {
                const w_breite = getValue(this.props.wt.W_BREITE);
                const SO23 = getValue(this.props.wt.SO23);
                const SO67 = getValue(this.props.wt.SO67);
                return w_breite + SO23 + SO67;
            }
        }
    }

}

function mapStateToProps({wt, locale}) {
    return {
        translate:       getTranslate(locale),
        currentLanguage: getActiveLanguage(locale).code,
        wt,
    }
}

export default connect(mapStateToProps, actions)(WtSummary);



// WEBPACK FOOTER //
// ./src/components/download/additionalInfo/summary/WtSummary.js